export enum AnalyticsActions {
    DR_LEADFORM_SKIPPED = 'DR_LEADFORM_SKIPPED',
    DR_LEAD_FORM_DISPLAYED = 'DR_LEAD_FORM_DISPLAYED',
    DR_OFFER_SUBMISSION_CLICKED = 'DR_OFFER_SUBMISSION_CLICKED'
}
